<div class="topBar">
</div>
<div class="loginHeader">
  <img src="assets/login-duke-logo.svg" class="loginLogo">
</div>
<div style="height: calc(100vh - 8.563rem); overflow-y: auto; background: #ffffff;">
  <div class="loginHeaders">
    <div class="rowNoMargins" style="text-align: center; display: block;">
      <img src="assets/mmaps-logo.svg" class="mmapsLogo">
    </div>
    <div class="rowNoMargins" style="text-align: center; display: block;">
      <div class="subHeader2">Match Maker Auto Project Setup</div>
    </div>
    <!--MOVE ERROR DIV to here-->
  </div>
</div>
<app-footer></app-footer>